module.exports = __webpack_public_path__ + "static/media/selected-eye.d954ec26.svg";